import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { VscChevronDown } from 'react-icons/vsc';
import { WrappedFieldProps } from 'redux-form';

interface SelectOption {
  disabled?: boolean;
  value: string | number;
  displayValue: string;
}

interface SelectField {
  title?: string;
  tooltip_id?: string;
  tooltip_text?: string;
  options: SelectOption[];
  labelClass?: string;
}

interface SelectProps extends WrappedFieldProps {
  field: SelectField;
  disabled?: boolean;
}

const Select: React.FC<SelectProps> = ({
  input,
  field: { title, tooltip_id, tooltip_text, options, labelClass },
  meta: { touched, error },
  disabled
}) => (
  <div className="form-group">
    {title && (
      <label className={`${labelClass} form-control-label mb-2`}>
        {title}
        {tooltip_id && tooltip_text && (
          <i id={tooltip_id} className="m-l-5 fa fa-icon fa-question-circle">
            <UncontrolledTooltip placement="right" target={tooltip_id}>
              {tooltip_text}
            </UncontrolledTooltip>
          </i>
        )}
      </label>
    )}
    <div className="select-wrapper">
      <select
        {...input}
        disabled={disabled}
        className={touched && error ? 'form-control is-invalid' : 'form-control'}
      >
        {options.map((option, index) => (
          <option disabled={option.disabled} value={option.value} key={index}>
            {option.displayValue}
          </option>
        ))}
      </select>
      <VscChevronDown size={12} className="dropdown-icon" />
    </div>
    {touched &&
      error &&
      error.map((errorMsg: string, i: number) => (
        <div key={i} className="invalid-feedback">
          {errorMsg}
        </div>
      ))}
  </div>
);

export default Select;
